import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import { useCalendarQuery } from "PFCore/hooks/queries/bookings/booking_config/use_calendar_query";
import { useExceptionDaysQuery } from "PFCore/hooks/queries/bookings/booking_config/use_exception_days_query";
import { useNominalDaysQuery } from "PFCore/hooks/queries/bookings/booking_config/use_nominal_days_query";
import { ExceptionDay, NominalDay } from "PFTypes/booking/booking_config";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { EditBookingCalendar } from "./edit_booking_calendar";

export const EditBookingCalendarController = () => {
  const { t } = useTranslation("bookingModule");
  const { id } = useParams<{ id: string }>();

  const { data: calendarData, isLoading: isCalendarLoading } = useCalendarQuery(id);
  const { data: nominalDaysData, isLoading: isNominalDaysLoading } = useNominalDaysQuery(id);
  const { data: exceptionDaysData, isLoading: isExceptionDaysLoading } = useExceptionDaysQuery(id);
  const WrappedEditBookingCalendar = usePageWrapper(EditBookingCalendar);

  return (
    <WrappedEditBookingCalendar
      loading={isCalendarLoading || isNominalDaysLoading || isExceptionDaysLoading}
      errors={
        (!calendarData && !isCalendarLoading) ||
        (!nominalDaysData && !isNominalDaysLoading) ||
        (!exceptionDaysData && !isExceptionDaysLoading)
          ? [t("config.calendars.errorLoadingBMCalendar")]
          : []
      }
      errorComponent={<NotFoundComponent message={t("config.calendars.contentCouldntBeLoaded")} />}
      calendar={calendarData}
      nominalDays={(nominalDaysData?.entries ?? []) as NominalDay[]}
      exceptionDays={(exceptionDaysData?.entries ?? []) as ExceptionDay[]}
    />
  );
};
